import type { BaseTariff } from './types';

export const filterActiveTariffs = (
  tariffs: BaseTariff[],
  activeCompanyIds: string[],
): BaseTariff[] =>
  tariffs.filter((tariff: BaseTariff) =>
    activeCompanyIds.includes(tariff.gesellschaft.id),
  );

export const filterTariffs = (
  tariffs: BaseTariff[],
  searchValues: string[],
): { matches: BaseTariff[]; mismatches: BaseTariff[] } => {
  const matches: BaseTariff[] = [];
  const mismatches: BaseTariff[] = [];

  tariffs.forEach((tariff) => {
    const searchFieldValues = [tariff.gesellschaft.name, tariff.name];

    if (tariff.beschreibung !== undefined) {
      searchFieldValues.push(tariff.beschreibung);
    }

    const hasMatch = searchFieldValues.some((val) => {
      const lowerCase = val.toLowerCase();
      return searchValues.some(
        (filterItem) => lowerCase.indexOf(filterItem.toLowerCase()) > -1,
      );
    });

    if (hasMatch) {
      matches.push(tariff);
    } else {
      mismatches.push(tariff);
    }
  });

  return {
    matches,
    mismatches,
  };
};

export const applyTranslation = (message: string): string => {
  return message.replaceAll('Zuers Zone', 'ZÜRS Zone');
};
